import React from 'react';
import { Box } from '@mui/material';

interface FlagProps {
   countryCode: string;
   alt: string;
}

const Flag: React.FC<FlagProps> = ({ countryCode, alt }) => (
   <Box
      sx={{
         width: 56,
         height: 56,
         borderRadius: '50%',
         overflow: 'hidden',
         border: '2px solid white',
         boxShadow: 2,
      }}
   >
      <img
         src={`https://flagcdn.com/w160/${countryCode}.png`}
         alt={alt}
         style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
   </Box>
);

export const FrenchFlag = () => <Flag countryCode="fr" alt="Français" />;
export const EnglishFlag = () => <Flag countryCode="gb" alt="English" />;
export const GermanFlag = () => <Flag countryCode="de" alt="Deutsch" />;

interface FlagsContainerProps {
   children: React.ReactNode;
}

export const FlagsContainer: React.FC<FlagsContainerProps> = ({ children }) => (
   <Box
      sx={{
         position: 'absolute',
         top: -8,
         right: -8,
         display: 'flex',
         flexDirection: 'column',
         gap: 0.5,
      }}
   >
      {children}
   </Box>
);
